import { u as x } from "./use-product-y102e61c.js";
import { u as j } from "./use-cart-D8NOb7eE.js";
import { u as E, a as C, m, q as N, o as F, b as I, c as l, e as a, f, h as T, k as n, g as t, F as P, p as V, t as g, w as D, i as q, l as Q, n as $, a5 as U } from "./define-element-XpjsV6s1.js";
import { i as v } from "./utils-CMsllPx8.js";
import { B as W } from "./Button-D5lKR5Sd.js";
import { Q as G } from "./QuantitySelect-ZqpfOW1n.js";
import { f as J } from "./format-currency-D_QngrXg.js";
import { L as K } from "./Loader-CeIJU_1y.js";
import { _ as X } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const Y = {
  class: "offset-product-details",
  ref: "container"
}, Z = { key: 0 }, ee = { key: 1 }, se = {
  key: 2,
  class: "offset-product-details-body"
}, te = { class: "offset-product-details-images" }, le = ["src", "alt", "loading"], ae = { class: "offset-product-details-content" }, ne = { class: "offset-product-details-title" }, ie = ["innerHTML"], oe = { key: 0 }, ue = {
  key: 0,
  class: "badge badge-secondary product-badge"
}, re = ["innerHTML"], ce = { class: "offset-product-details-specs" }, pe = { key: 0 }, de = ["innerHTML"], ve = { key: 1 }, _e = ["innerHTML"], me = { key: 2 }, fe = ["innerHTML"], ye = { key: 3 }, ge = ["innerHTML"], He = { key: 4 }, Le = ["innerHTML"], Te = { key: 5 }, Me = ["innerHTML"], ke = { key: 6 }, he = ["innerHTML"], be = { key: 7 }, Se = ["innerHTML"], xe = { key: 8 }, Ce = ["innerHTML"], Pe = { key: 9 }, Ve = ["innerHTML"], De = { key: 10 }, qe = ["innerHTML"], ze = { key: 11 }, Be = ["innerHTML"], we = { key: 12 }, Ae = ["innerHTML"], Oe = { key: 13 }, Re = ["innerHTML"], je = { key: 14 }, Ee = ["innerHTML"], Ne = { key: 15 }, Fe = ["innerHTML"], Ie = { key: 16 }, Qe = ["innerHTML"], $e = { key: 17 }, Ue = ["innerHTML"], We = { key: 18 }, Ge = ["innerHTML"], Je = { key: 19 }, Ke = ["innerHTML"], Xe = { key: 20 }, Ye = ["innerHTML"], Ze = { key: 21 }, es = ["innerHTML"], ss = { key: 22 }, ts = ["innerHTML"], ls = { key: 23 }, as = ["innerHTML"], ns = { key: 24 }, is = ["innerHTML"], os = { key: 25 }, us = ["innerHTML"], rs = { key: 26 }, cs = ["innerHTML"], ps = { class: "offset-product-details-purchase" }, ds = { class: "offset-options" }, vs = { class: "offset-price" }, _s = { class: "offset-variants" }, ms = { class: "offset-buy" }, fs = {
  __name: "ProductDetails",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    sku: {
      type: String,
      required: !0
    },
    // Optional — when set, only variants that also belong to this category are
    // shown in the bottle-size selector (a variant tagged into a different
    // category, or no category at all, is left out even though it's a real
    // sibling of this product). Leave unset to show every known variant
    // regardless of category, same as before this existed.
    collectionSlug: {
      type: String,
      default: ""
    },
    slots: {
      type: Object,
      default: () => ({})
    }
  },
  setup(z) {
    const y = z, { isPending: H, data: M } = x(null), { data: k } = x(y.collectionSlug || !1), { addToCart: B } = j(), w = E("container"), _ = C(1), u = C(""), e = m(() => v(M.value) ? null : M.value.find((i) => i.sku === y.sku)), h = m(() => {
      if (!y.collectionSlug || v(k.value))
        return null;
      const i = /* @__PURE__ */ new Set();
      return k.value.forEach((s) => {
        var p;
        i.add(s.sku), (p = s.variants) == null || p.forEach((r) => i.add(r.sku));
      }), i;
    }), o = m(() => {
      var p;
      if (v(e.value))
        return {};
      const i = v(e.value.bottle_size) ? "750ml" : e.value.bottle_size, s = {
        [e.value.sku]: {
          name: e.value.name,
          bottle_size: i,
          price: e.value.price,
          max_purchase_quantity: e.value.max_purchase_quantity
        }
      };
      return (p = e.value.variants) == null || p.forEach((r) => {
        h.value && !h.value.has(r.sku) || (s[r.sku] = {
          name: r.name,
          bottle_size: r.bottle_size,
          price: r.price,
          // Each variant/bottle-size can have its own real limit (already
          // resolved against its own purchase_limit by use-product.ts) —
          // without this, addToCart() always fell back to the top-level
          // product's own max_purchase_quantity regardless of which variant
          // was actually selected/added.
          max_purchase_quantity: r.max_purchase_quantity
        });
      }), s;
    });
    N(
      e,
      (i) => {
        i && (u.value = i.sku, _.value = 1);
      },
      { immediate: !0 }
    );
    function A(i) {
      return Math.round(parseFloat(i) * 100) % 100 === 0;
    }
    const O = m(() => Object.values(o.value).every((i) => A(i.price))), R = m(() => {
      if (v(e.value))
        return [];
      const i = e.value, s = [];
      return v(i.image) || s.push(i.image), v(i.image_alt) || s.push(i.image_alt_medium || i.image_alt), v(i.image_alt_3) || s.push(i.image_alt_3_medium || i.image_alt_3), s;
    });
    return F(() => {
      I(w.value, y.inheritStyle);
    }), (i, s) => {
      var p, r, b, S;
      return l(), a("div", Y, [
        f(H) ? (l(), a("div", Z, [
          T(K)
        ])) : n("", !0),
        !f(H) && !e.value ? (l(), a("div", ee, "Product not found.")) : n("", !0),
        !f(H) && e.value ? (l(), a("div", se, [
          t("div", te, [
            (l(!0), a(P, null, V(R.value, (d, c) => {
              var L;
              return l(), a("figure", {
                key: c,
                class: "offset-product-details-image"
              }, [
                t("img", {
                  src: d,
                  alt: (((L = o.value[u.value]) == null ? void 0 : L.name) || "") + " " + (e.value.subtitle || ""),
                  loading: c === 0 ? "eager" : "lazy",
                  decoding: "async"
                }, null, 8, le)
              ]);
            }), 128))
          ]),
          t("div", ae, [
            t("h1", ne, [
              t("span", {
                innerHTML: e.value.label || ((p = o.value[u.value]) == null ? void 0 : p.name)
              }, null, 8, ie),
              e.value.subtitle ? (l(), a("small", oe, g(e.value.subtitle), 1)) : n("", !0)
            ]),
            e.value.product_badge ? (l(), a("span", ue, g(e.value.product_badge), 1)) : n("", !0),
            e.value.additional_description ? (l(), a("div", {
              key: 1,
              class: "offset-product-details-description",
              innerHTML: e.value.additional_description
            }, null, 8, re)) : n("", !0),
            t("ul", ce, [
              e.value.varietal ? (l(), a("li", pe, [
                s[3] || (s[3] = t("span", { class: "spec-title" }, "Varietal", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.varietal
                }, null, 8, de)
              ])) : n("", !0),
              e.value.vintage ? (l(), a("li", ve, [
                s[4] || (s[4] = t("span", { class: "spec-title" }, "Vintage", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.vintage
                }, null, 8, _e)
              ])) : n("", !0),
              e.value.winemaker ? (l(), a("li", me, [
                s[5] || (s[5] = t("span", { class: "spec-title" }, "Winemaker", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.winemaker
                }, null, 8, fe)
              ])) : n("", !0),
              e.value.vineyard ? (l(), a("li", ye, [
                s[6] || (s[6] = t("span", { class: "spec-title" }, "Vineyard", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.vineyard
                }, null, 8, ge)
              ])) : n("", !0),
              e.value.harvest_date ? (l(), a("li", He, [
                s[7] || (s[7] = t("span", { class: "spec-title" }, "Harvest Date", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.harvest_date
                }, null, 8, Le)
              ])) : n("", !0),
              e.value.appellation ? (l(), a("li", Te, [
                s[8] || (s[8] = t("span", { class: "spec-title" }, "Appellation", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.appellation
                }, null, 8, Me)
              ])) : n("", !0),
              e.value.region ? (l(), a("li", ke, [
                s[9] || (s[9] = t("span", { class: "spec-title" }, "Region", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.region
                }, null, 8, he)
              ])) : n("", !0),
              e.value.sub_region ? (l(), a("li", be, [
                s[10] || (s[10] = t("span", { class: "spec-title" }, "Sub-Region", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.sub_region
                }, null, 8, Se)
              ])) : n("", !0),
              e.value.clones ? (l(), a("li", xe, [
                s[11] || (s[11] = t("span", { class: "spec-title" }, "Clones", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.clones
                }, null, 8, Ce)
              ])) : n("", !0),
              e.value.vine_age ? (l(), a("li", Pe, [
                s[12] || (s[12] = t("span", { class: "spec-title" }, "Age of Vines at Harvest", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.vine_age
                }, null, 8, Ve)
              ])) : n("", !0),
              e.value.soil ? (l(), a("li", De, [
                s[13] || (s[13] = t("span", { class: "spec-title" }, "Soil", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.soil
                }, null, 8, qe)
              ])) : n("", !0),
              e.value.farming_method ? (l(), a("li", ze, [
                s[14] || (s[14] = t("span", { class: "spec-title" }, "Farming Method", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.farming_method
                }, null, 8, Be)
              ])) : n("", !0),
              e.value.blend ? (l(), a("li", we, [
                s[15] || (s[15] = t("span", { class: "spec-title" }, "Blend", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.blend
                }, null, 8, Ae)
              ])) : n("", !0),
              e.value.oak ? (l(), a("li", Oe, [
                s[16] || (s[16] = t("span", { class: "spec-title" }, "Oak", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.oak
                }, null, 8, Re)
              ])) : n("", !0),
              e.value.aging ? (l(), a("li", je, [
                s[17] || (s[17] = t("span", { class: "spec-title" }, "Barrel Aging", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.aging
                }, null, 8, Ee)
              ])) : n("", !0),
              e.value.stainless ? (l(), a("li", Ne, [
                s[18] || (s[18] = t("span", { class: "spec-title" }, "Stainless", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.stainless
                }, null, 8, Fe)
              ])) : n("", !0),
              e.value.residual_sugar ? (l(), a("li", Ie, [
                s[19] || (s[19] = t("span", { class: "spec-title" }, "Residual Sugar", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.residual_sugar
                }, null, 8, Qe)
              ])) : n("", !0),
              e.value.brix_at_harvest ? (l(), a("li", $e, [
                s[20] || (s[20] = t("span", { class: "spec-title" }, "Brix at Harvest", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.brix_at_harvest
                }, null, 8, Ue)
              ])) : n("", !0),
              e.value.alcohol ? (l(), a("li", We, [
                s[21] || (s[21] = t("span", { class: "spec-title" }, "Alcohol", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.alcohol + "%"
                }, null, 8, Ge)
              ])) : n("", !0),
              e.value.ph ? (l(), a("li", Je, [
                s[22] || (s[22] = t("span", { class: "spec-title" }, "PH", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.ph
                }, null, 8, Ke)
              ])) : n("", !0),
              e.value.ta ? (l(), a("li", Xe, [
                s[23] || (s[23] = t("span", { class: "spec-title" }, "TA", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.ta + "g/100mLs"
                }, null, 8, Ye)
              ])) : n("", !0),
              e.value.case_production ? (l(), a("li", Ze, [
                s[24] || (s[24] = t("span", { class: "spec-title" }, "Production", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.case_production
                }, null, 8, es)
              ])) : n("", !0),
              e.value.production && !e.value.case_production ? (l(), a("li", ss, [
                s[25] || (s[25] = t("span", { class: "spec-title" }, "Production", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.production
                }, null, 8, ts)
              ])) : n("", !0),
              e.value.release_date ? (l(), a("li", ls, [
                s[26] || (s[26] = t("span", { class: "spec-title" }, "Release Date", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.release_date
                }, null, 8, as)
              ])) : n("", !0),
              e.value.upc ? (l(), a("li", ns, [
                s[27] || (s[27] = t("span", { class: "spec-title" }, "UPC", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.upc
                }, null, 8, is)
              ])) : n("", !0),
              e.value.press ? (l(), a("li", os, [
                s[28] || (s[28] = t("span", { class: "spec-title" }, "Press", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.press
                }, null, 8, us)
              ])) : n("", !0),
              e.value.score ? (l(), a("li", rs, [
                s[29] || (s[29] = t("span", { class: "spec-title" }, "Score", -1)),
                t("span", {
                  class: "spec-value",
                  innerHTML: e.value.score
                }, null, 8, cs)
              ])) : n("", !0)
            ]),
            t("div", ps, [
              t("div", ds, [
                t("div", vs, g(f(J)((r = o.value[u.value]) == null ? void 0 : r.price, O.value)), 1),
                t("div", _s, [
                  (l(!0), a(P, null, V(o.value, (d, c) => (l(), Q(U(Object.keys(o.value).length > 1 ? "button" : "span"), {
                    key: c,
                    type: Object.keys(o.value).length > 1 ? "button" : void 0,
                    "aria-pressed": Object.keys(o.value).length > 1 ? u.value === c : void 0,
                    onClick: (L) => Object.keys(o.value).length > 1 && (u.value = c),
                    class: $({ active: u.value === c })
                  }, {
                    default: D(() => [
                      q(g(d.bottle_size), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "aria-pressed", "onClick", "class"]))), 128))
                ])
              ]),
              t("div", ms, [
                T(G, {
                  modelValue: _.value,
                  "onUpdate:modelValue": s[0] || (s[0] = (d) => _.value = d),
                  onChange: s[1] || (s[1] = (d) => _.value = d),
                  max: (b = o.value[u.value]) == null ? void 0 : b.max_purchase_quantity,
                  min: 1
                }, null, 8, ["modelValue", "max"]),
                T(W, {
                  "aria-label": `Add ${(S = o.value[u.value]) == null ? void 0 : S.name} to cart`,
                  onClick: s[2] || (s[2] = (d) => {
                    var c;
                    return f(B)(u.value, _.value, {
                      maxPurchaseQuantity: (c = o.value[u.value]) == null ? void 0 : c.max_purchase_quantity
                    });
                  })
                }, {
                  default: D(() => s[30] || (s[30] = [
                    q(" ADD ", -1)
                  ])),
                  _: 1,
                  __: [30]
                }, 8, ["aria-label"])
              ])
            ])
          ])
        ])) : n("", !0)
      ], 512);
    };
  }
}, Ss = /* @__PURE__ */ X(fs, [["__scopeId", "data-v-8761e656"]]);
export {
  Ss as P
};
